import _ from 'lodash';
import { ref } from '@vue/composition-api';
import { $api } from '@/store/ApiClient';
import sampleResponse from '@/assets/sampleData/PB-1789_SampleResponse.json';

// const isMock = true;
const isMock = false;

export function useBffSearchFlowDocument(options = {}) {
  const { initialQueries = {}, immediate = false } = options;

  const data = ref(null);
  const loading = ref(false);
  const error = ref(null);

  const fetchData = async (queries = initialQueries) => {
    loading.value = true;
    error.value = null;

    const params = {
      lslConfig: {
        serviceCode: 'tw-transaction-bff-api',
        apiCode: 'get_/v1/attach-file/searchFlowDocument',
        query: {
          tradingId: queries.tradingId,
          tradingFlowId: queries.tradingFlowId || '1',
          limit: queries.limit || 20,
          offset: queries.offset || 0,
          sort: queries.sort || {
            target: ['processName'],
            sortType: ['ASC'],
          },
        },
      },
    };

    try {
      if (isMock) {
        // モックデータを使用（1秒遅延でローディングをシミュレート）
        await new Promise((resolve) => {
          setTimeout(() => {
            data.value = sampleResponse;
            resolve();
          }, 1000);
        });
      } else {
        const res = await $api.request(params);
        data.value = res;
      }
    } catch (err) {
      error.value = err;
      console.error('useBffSearchFlowDocument error:', err);
      // 呼び出し側でエラーハンドリングできるように、エラーを再スローする
      throw err;
    } finally {
      loading.value = false;
    }
  };

  if (immediate) fetchData();

  return {
    data,
    loading,
    error,
    refresh: fetchData,
  };
}
